<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <base-dropdown v-if="activeModules.length > 0">
                <base-button slot="title" type="warning" class="dropdown-toggle">
                    Basic Sales Reports - {{_.startCase(currentProfile)}}
                </base-button>
                <a v-for="profile in activeModules" :key="profile.id"
                    @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)"
                    class="dropdown-item" href="#">{{profile.name}}</a>
            </base-dropdown>
            <base-dropdown v-else>
                <base-button slot="title" type="primary" class="dropdown-toggle">
                    Basic Sales Reports
                </base-button>
                <a class="dropdown-item" disabled>No active module/s under this feature</a>
            </base-dropdown>
        </base-header>
        <!-- <img style="display: none;" id='reportLogo' :src="imagepath" alt='Report Logo' crossorigin="anonymous"/> -->
        <div id="logoDiv" style="display: none;"></div>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <item-returns-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'item_returns_reports'"></item-returns-report>
                    <item-sales-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'item_sales_reports'"></item-sales-report>
                    <matrix-sales-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'matrix_sales_reports'"></matrix-sales-report>
                    <category-sales-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'category_sales_reports'"></category-sales-report>
                    <category-returns-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'category_returns_reports'"></category-returns-report>
                    <!-- bryan -->
                    <sell-through-rate-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'sell_through_rate_reports'"></sell-through-rate-report>
                    <!-- end -->
                    <stock-valuation-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'stock_valuation_reports'"></stock-valuation-report>
                    <stock-valuation-summary :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'stock_valuation_summaries'"></stock-valuation-summary>
                    <general-inventory-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'general_inventory_reports'"></general-inventory-report>
                    <item-sales-profit :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'item_sales_profits'"></item-sales-profit>
                    <inventory-aging-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'inventory_aging_reports'"></inventory-aging-report>
                    <inventory-aging-valuation :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'inventory_aging_valuations'"></inventory-aging-valuation>
                    <stock-activity-valuation :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'stock_activity_valuations'"></stock-activity-valuation>
                    <oms-collection-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'oms_collection_reports'"></oms-collection-report>
                    <oms-daily-sales-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'oms_daily_sales_reports'"></oms-daily-sales-report>
                    <hourly-sales-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'hourly_sales_reports'"></hourly-sales-report>
                    <wallet-payment-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'pos_e_wallet_payment_reports'"></wallet-payment-report>
                    <sales-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'sales_reports'"></sales-report>
                    <TopSellingItemsReport :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'top_selling_items_with_inventory_reports'"></TopSellingItemsReport>
                    <ProfitReport :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'profit_reports'"></ProfitReport>
                    <NegativeMarginSkusReport :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'negative_margin_skus_reports'"></NegativeMarginSkusReport>
                    <reservation-report :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'reservation_reports'"></reservation-report>
                    <TopCustomerReport :access_rights="accessRights" :access_costprice_rights="accessCostPriceRights" v-if="currentProfile == 'top_customers_reports'"></TopCustomerReport>
                    <SalesmanCommissionReport :access_rights="accessRights" v-if="currentProfile == 'salesman_commission_reports'"></SalesmanCommissionReport>
                    <DetailedDiscountReport :access_rights="accessRights" v-if="currentProfile == 'detailed_discount_reports'"></DetailedDiscountReport>
                    <PosPaymentReport :access_rights="accessRights" v-if="currentProfile == 'pos_payment_reports'"></PosPaymentReport>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import ItemReturnsReport from '../Basic Sales Reports/ItemReturnsReport';
    import ItemSalesReport from '../Basic Sales Reports/ItemSalesReport';
    import MatrixSalesReport from '../Basic Sales Reports/MatrixSalesReport';
    import CategorySalesReport from '../Basic Sales Reports/CategorySalesReport';
    import CategoryReturnsReport from '../Basic Sales Reports/CategoryReturnsReport';
    import SellThroughRateReport from '../Basic Sales Reports/SellThroughRateReport';
    import StockValuationReport from '../Basic Sales Reports/StockValuationReport';
    import StockValuationSummary from '../Basic Sales Reports/StockValuationSummary';
    import GeneralInventoryReport from '../Basic Sales Reports/GeneralInventoryReport';
    import ItemSalesProfit from '../Basic Sales Reports/ItemSalesProfit';
    import InventoryAgingReport from '../Basic Sales Reports/InventoryAgingReport';
    import InventoryAgingValuation from '../Basic Sales Reports/InventoryAgingValuation';
    import StockActivityValuation from '../Basic Sales Reports/StockActivityValuation';
    import OmsCollectionReport from '../Basic Sales Reports/OmsCollectionReport';
    import OmsDailySalesReport from '../Basic Sales Reports/OmsDailySalesReport';
    import HourlySalesReport from '../Bir Reports/HourlySalesReport';
    import WalletPaymentReport from '../Basic Sales Reports/WalletPaymentReport';
    import SalesReport from './SalesReport.vue';
    import TopSellingItemsReport from './TopSellingItemsWithInventoryReport.vue';
    import ProfitReport from './ProfitReport.vue';
    import NegativeMarginSkusReport from './NegativeMarginSkusReport.vue';
    import ReservationReport from './ReservationReport.vue';
    import TopCustomerReport from './TopCustomerReport.vue';
    import SalesmanCommissionReport from './SalesmanCommissionReport.vue';
    import DetailedDiscountReport from './DetailedDiscountReport.vue';
    import PosPaymentReport from './PosPaymentReport.vue';
    import {
        mapState,
        mapActions
    } from 'vuex'

    export default {
        data() {
            return {
                activeModules: [],
                accessRights: [],
                accessCostPriceRights: [],
                imagepath: secureStorage.getItem("account_logo")
            }
        },
        mounted: async function () {
            var component_x = this;
            
            //Fix: S3 image CORS error in jsPDF
            // const corsImageModified = new Image();
            // corsImageModified.crossOrigin = "Anonymous";
            // corsImageModified.id = "reportLogo";
            // corsImageModified.src = secureStorage.getItem("account_logo") + "?not-from-cache-please";
            // document.getElementById("logoDiv").appendChild(corsImageModified);
            //Fix: S3 image CORS error in jsPDF

            var categoryId = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories?code=R-001&status=A', null, null)
            if(categoryId[0] != undefined){
                component_x.activeModules = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories/' + categoryId[0].id + '/enabled_modules', null, null)
                if (component_x.activeModules.length > 0) {
                    var profile = _.snakeCase(component_x.activeModules[0].name)
                    component_x.setCurrentProfile(_.pluralize(profile), component_x.activeModules[0].id);
                } else {
                    component_x.setCurrentProfile(null, null);
                }
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components: {
            ItemReturnsReport,
            ItemSalesReport,
            MatrixSalesReport,
            CategorySalesReport,
            CategoryReturnsReport,
            SellThroughRateReport,
            StockValuationReport,
            StockValuationSummary,
            GeneralInventoryReport,
            ItemSalesProfit,
            InventoryAgingReport,
            InventoryAgingValuation,
            StockActivityValuation,
            OmsCollectionReport,
            OmsDailySalesReport,
            HourlySalesReport,
            WalletPaymentReport,
            SalesReport,
            TopSellingItemsReport,
            ProfitReport,
            NegativeMarginSkusReport,
            ReservationReport,
            TopCustomerReport,
            SalesmanCommissionReport,
            DetailedDiscountReport,
            PosPaymentReport
        },
        methods: {
            ...mapActions(['updateCurrentProfile', 'updateParameters']),
            async setCurrentProfile(profile, id) {
                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
                if (_.isEmpty(accessRightsRequest.access_rights) == false){
                    this.accessRights = accessRightsRequest.access_rights[id]
                }else {
                    this.accessRights = []
                }

                var accessCostPriceRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=123", null)
                if (_.isEmpty(accessCostPriceRightsRequest.access_rights) == false){
                    this.accessCostPriceRights = accessCostPriceRightsRequest.access_rights[123]
                }else {
                    this.accessCostPriceRights = []
                }
                this.updateCurrentProfile(profile);
            }
        }
    };
</script>

<style></style>